import React from "react";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Card, CardBody, Col, Row, Input, Button } from "reactstrap";

const labelStyle = {
  fontSize: "12px",
  fontWeight: "600",
  color: "#6c757d",
  textTransform: "uppercase",
  letterSpacing: "0.4px",
};

const fieldStyle = {
  padding: "5px 10px",
  background: "#f8f9fa",
  border: "1px solid #dee2e6",
  borderRadius: "4px",
  fontSize: "13px",
  minHeight: "31px",
  display: "flex",
  alignItems: "center",
  color: "#343a40",
};

function FieldPair({ label, children }) {
  return (
    <Col xs={6}>
      <Row className="align-items-center mb-2">
        <Col xs={5} style={labelStyle}>
          {label}
        </Col>
        <Col xs={7}>{children}</Col>
      </Row>
    </Col>
  );
}

function ReadOnly({ value }) {
  return <div style={fieldStyle}>{value}</div>;
}

export default function SalesItemsHeadBody({
  onChangeHead,
  headValues,
  flag,
  handleEditable,
  onUpdateHead,
  handleBack,
  options,
}) {
  const formatDate = (strDate) => {
    if (!strDate) return "";
    const [day, month, year] = strDate.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  return (
    <Card
      style={{
        marginTop: "5px",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        border: "1px solid #e9ecef",
      }}
    >
      <CardBody style={{ padding: "16px 20px" }}>
        <Row>
          <FieldPair label="Bill Date">
            <Input
              bsSize="sm"
              type="date"
              name="billDate"
              id="billDate"
              onChange={onChangeHead}
              disabled={flag}
              value={formatDate(headValues.billDate)}
            />
          </FieldPair>
          <FieldPair label="Payment Type">
            <Input
              bsSize="sm"
              type="select"
              name="paymentType"
              id="paymentType"
              value={headValues.paymentType || "0"}
              onChange={onChangeHead}
              disabled={flag}
            >
              <option value="0">Select</option>
              {options.map((option) => (
                <option key={option.id} value={option.configKey}>
                  {option.configValue}
                </option>
              ))}
            </Input>
          </FieldPair>
        </Row>
        <Row>
          <FieldPair label="Party Name">
            <ReadOnly value={headValues.partyName || "-"} />
          </FieldPair>
          <FieldPair label="Invoice Number">
            <ReadOnly value={headValues.invoiceNumber || "-"} />
          </FieldPair>
        </Row>
        <Row>
          <FieldPair label="Credit Adjustments">
            <ReadOnly value={headValues.creditAdjustments || "0"} />
          </FieldPair>
          <FieldPair label="Outpay Adjustments">
            <ReadOnly value={headValues.outputPayAdjustments || "0"} />
          </FieldPair>
        </Row>
        <Row>
          <FieldPair label="Scheme Discount">
            <ReadOnly value={headValues.schemeDiscount || "0"} />
          </FieldPair>
          <FieldPair label="Shikar Scheme">
            <ReadOnly value={headValues.shikarScheme || "0"} />
          </FieldPair>
        </Row>
        <Row>
          <FieldPair label="Bill Value">
            <ReadOnly value={headValues.billValue || "0"} />
          </FieldPair>
          <FieldPair label="Net Sales">
            <ReadOnly value={headValues.netSales || "0"} />
          </FieldPair>
        </Row>
        <Row>
          <FieldPair label="Sales Person Name">
            <ReadOnly value={headValues.salesPersonName || "-"} />
          </FieldPair>
          <FieldPair label="GSN Number">
            <Input
              bsSize="sm"
              type="text"
              name="gsnNumber"
              id="gsnNumber"
              onChange={onChangeHead}
              disabled={flag}
              value={headValues.gsnNumber || ""}
              placeholder="Enter GSN Number"
            />
          </FieldPair>
        </Row>
        <Row className="mt-3">
          <Col className="text-right">
            {flag ? (
              <Button onClick={handleEditable} color="info" size="sm">
                Edit
              </Button>
            ) : (
              <Button onClick={onUpdateHead} color="warning" size="sm">
                Update
              </Button>
            )}
            <Button
              onClick={handleBack}
              color="danger"
              size="sm"
              style={{ marginLeft: "8px" }}
            >
              Back
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/SalesItemsHeadBody.js